export default __webpack_public_path__ + "static/media/UiLogout.a052e5af.svg";